// 请假功能模块api
import { request } from "@/utils/request";

// 请假列表
export function getLeaveList(params) {
  return request({
    url: "/employee/leave/1.0/leaveList",
    method: "POST",
    params,
  });
}
// 提交请假
export function submitLeave(params) {
  return request({
    url: "/employee/leave/1.0/add",
    method: "POST",
    params,
  });
}

// 获取审批列表
export function getAuditList(params) {
  return request({
    url: "/employee/leave/1.0/leaveAuditList",
    method: "POST",
    params,
  });
}
// 请假审批
export function leaveAudit(params) {
  return request({
    url: "/employee/leave/1.0/leaveAudit",
    method: "POST",
    params,
  });
}
